import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { CreditGateRequiredAction } from "@/hooks/useCreditGateModal";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  requiredAction?: CreditGateRequiredAction;
  userEffectiveAvailable?: string | number | null;
};

/** Inform-only: no plan list or checkout, since those routes are company-admin only. */
export const InsufficientCreditsMemberNotice = ({
  open,
  onOpenChange,
  requiredAction,
  userEffectiveAvailable,
}: Props) => {
  const availableCopy =
    userEffectiveAvailable !== undefined && userEffectiveAvailable !== null
      ? `You currently have ${Number(userEffectiveAvailable).toLocaleString()} credits available. `
      : "";

  const description =
    requiredAction === "ask_company_admin_to_allocate"
      ? `${availableCopy}Ask your company admin to allocate credits to your account.`
      : `${availableCopy}You do not have enough credits to continue. Ask your company admin for help.`;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Insufficient credits</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>Confirm</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default InsufficientCreditsMemberNotice;
